import transInitialFun from './main'
export default transInitialFun()

transInitialFun().init()